module.exports = __webpack_public_path__ + "img/daily-star.73ba816c.svg";